import React from "react";
import Sidebar from "../Sidebar/Sidebar";
import { Outlet } from "react-router-dom";

function Layout() {
  return (
    <div className="d-flex layout-container">
      <Sidebar />
      <div className="flex-grow-1 d-flex flex-column" style={{ height: "100vh", overflow: "hidden" }}>
        <div style={{ flex: 1, width: "calc(100vw - 250px )", overflowY: "auto" }}>
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Layout;
